import { render, staticRenderFns } from "./Judges.vue?vue&type=template&id=048edbd9&scoped=true&"
import script from "./Judges.vue?vue&type=script&lang=js&"
export * from "./Judges.vue?vue&type=script&lang=js&"
import style0 from "./Judges.vue?vue&type=style&index=0&id=048edbd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048edbd9",
  null
  
)

export default component.exports